import React from 'react';
import { closing } from '../data/article';
import { ArticleFigure } from './ArticleFigure';
import { Prose } from './Prose';
import { CtaButton } from './CtaButton';
export function ClosingSection() {
  return <section className="px-5 py-12 sm:px-8 md:py-16" aria-labelledby="closing-heading" data-id="element-28" data-mp="12t3ppar3f1hx">
      <div className="mx-auto max-w-[42rem]" data-id="element-29" data-mp="xt8yt77bibwv">
        <h2 id="closing-heading" className="sr-only" data-id="element-30" data-mp="xsfra40jbido">
          Start keeping your dog safe today
        </h2>
        <Prose blocks={closing.blocks} data-id="element-31" data-mp="1cox46zodh52c" />
        <p className="mt-8 border-l-2 border-brand-600 pl-4 text-[22px] font-extrabold leading-snug tracking-[-0.01em] text-brand-700 sm:text-[26px]" data-id="element-32" data-mp="17sq59que8ttw">
          {closing.pull}
        </p>

        <ArticleFigure image={closing.image} className="mt-10" data-id="element-33" data-mp="1hh81durqacr7" />

        <CtaButton className="mt-10" size="lg" data-id="element-34" data-mp="1hjuh4horvyki">
          {closing.cta}
        </CtaButton>
      </div>
    </section>;
}